import React from 'react';
import { VFXEffectRegistry } from '../../../../effects/VFXEffectRegistry';
import {
  ParticlesTabProps, SectionLabel, ActionButton, InfoText,
  PARTICLE_PRESETS, eventBus,
} from './shared';
import { livePlayerPosition } from '../../../../systems/player/livePlayerPosition';

export const ParticlesTab: React.FC<ParticlesTabProps> = ({ ability: _ability, update: _update, player }) => {
  // Data-driven: combine legacy presets with registry-backed particle presets
  const registryPresets = VFXEffectRegistry.getAll()
    .filter(e => e.category === 'particle_preset')
    .map(e => e.id);
  const particleEffects = [...new Set([...PARTICLE_PRESETS, ...registryPresets])];

  return (
    <>
      <SectionLabel>Particle Effects</SectionLabel>
      <InfoText style={{ marginTop: 0, marginBottom: 8 }}>
        Particle presets used by this ability's VFX primitives.
      </InfoText>

      {particleEffects.map(pe => (
        <ActionButton key={pe} $variant="blue" onClick={() => {
          if (!player) return;
          eventBus.emit('vfx:spawn_particles', {
            effectId: pe,
            x: livePlayerPosition(player?.position).x + (player.facing === 'right' ? 50 : -50),
            y: livePlayerPosition(player?.position).y - 10,
            count: 10,
          });
        }}>
          ▶ {pe}
        </ActionButton>
      ))}
    </>
  );
};
